import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import useAxios from "../../../../hooks/useAxios";
import { useNavigate } from "react-router-dom";
import "./ManualModal.css";
import StyledTextField from "../../../common/StyledComponents/StyledTextField";
import ToggleSwitch from "../../../ToggleSwitch/ToggleSwitch";

const ManualModal = ({ open, onClose, classId }) => {
  const [title, setTitle] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [browserLock, setBrowserLock] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const axiosInstance = useAxios();
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImageFile(e.target.files[0]);
      setCoverImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleDeleteImage = () => {
    setImageFile(null);
    setCoverImage(null);
  };

  const handleCreateQuiz = async () => {
    setError(null);
    setLoading(true);

    const formData = new FormData();
    if (classId) {
        formData.append("class_id", classId);
    }
    if (imageFile) {
      formData.append("cover_image", imageFile);
    }
    if (title) {
      formData.append("title", title);
    }
    formData.append("hints_enabled", 1);
    formData.append("browser_lock", browserLock ? 1 : 0);

    try {
      const response = await axiosInstance.post("/quizzes/create", formData);

      if (response.data.success) {
        const quizId = response.data.quiz.id;
        navigate(`/quiz-review/${quizId}`);
      } else {
        setError(response.data.message || "Failed to create Assessment.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="manual-modal-title"
      aria-describedby="manual-modal-description"
    >
      <Box className="manual-modal-container">
        <Typography variant="h5" className="manual-modal-title">
          Create a New Assessment
        </Typography>
                  <StyledTextField
            label="Title"
            name="title"
            value={title}
            onChange={ e => setTitle(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          
          <Box sx={{ mt: 2, mb: 2 }}>
            <ToggleSwitch
              mainLabel="Browser Lock"
              labelLeft="Disabled"
              labelRight="Enabled"
              checked={browserLock}
              onChange={(e) => setBrowserLock(e.target.checked)}
            />
            <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
              When enabled, students cannot leave the session page until completion
            </Typography>
          </Box>
        <Box className="cover-image-container">
          {coverImage ? (
            <Box className="image-preview">
              <img src={coverImage} alt="Cover Preview" className="preview-image" />
              <Button
                variant="outlined"
                color="error"
                onClick={handleDeleteImage}
                className="delete-image-button"
              >
                Delete Image
              </Button>
            </Box>
          ) : (
            <Button
              onClick={() => document.getElementById("cover-image-input").click()}
              className="upload-image-button  text-button"
            >
              Upload Cover Image
            </Button>
          )}
          <input
            type="file"
            id="cover-image-input" 
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleImageChange}
          />
        </Box>

        {error && (
          <Typography variant="body2" color="error" className="error-message">
            {error}
          </Typography>
        )}

        <Button
          onClick={handleCreateQuiz}
          className="create-quiz-button primary-button"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Create Assessment"}
        </Button>
      </Box>
    </Modal>
  );
};

export default ManualModal;
